import { FC } from 'react';
import styled from 'styled-components';
import LinkedIn from '../../assets/icons/footer/linkedin.svg';
import Facebook from '../../assets/icons/footer/facebook.svg';
import Twitter from '../../assets/icons/footer/twitter.svg';

const Footer = styled.footer(({ theme }) => {
  const { color } = theme;
  return `
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 2rem;
        background: ${color.primary.dark};
        padding: 78px 80px;
    `;
});

const FooterColumn = styled.section(({ theme }) => {
  const { color, type } = theme;
  return `
        color: ${color.grayscale[1000]};
        font-family: ${type.face};
        font-size: ${type.size.small};
        line-height: 2;
    `;
});

const SocialIcon = styled.img`
  margin: 0px 5px 0px 5px;
  width: 20px;
  height: 20px;
`;

const Link = styled.a(({ theme }) => {
  const { type, color } = theme;
  return `
        display: flex;
        align-items:center;
        &:hover{
            font-weight: ${type.weight.black};
            color: ${color.grayscale[1000]};
        }
    `;
});

const ColumnHeader = styled.h2(({ theme }) => {
  const { type, color } = theme;
  return `
        font-size: ${type.size.small};
        font-weight: ${type.weight.bold};
        color: ${color.grayscale[1000]};
        margin-bottom: 0.5rem;
    `;
});

const FDALabel = styled.span(({ theme }) => {
  const { color, type } = theme;
  return `
        color: ${color.grayscale[1000]};
        font-size: ${type.size.small};
        font-weight: ${type.weight.bold};
        margin-right: 0.5rem;
    `;
});

const FDAMessage = styled.a(({ theme }) => {
  const { color, type } = theme;
  return `
        color: ${color.grayscale[1000]};
        font-size: ${type.size.small};
        margin-top: 1rem;
        &:hover{
            font-weight: ${type.weight.black};
            color: ${color.grayscale[1000]};
        }
    `;
});

export interface IPageFooter {
  isTherapy: boolean;
  champion: {
    firstName: string;
    lastName: string;
    email: string;
  };
}

const PageFooter: FC<IPageFooter> = ({ champion, isTherapy }) => {
  return (
    <Footer>
      <FooterColumn>
        <ColumnHeader>ABOUT RESTORE</ColumnHeader>
        <Link href="https://restoreskills.com/" target="_blank">
          The Company
        </Link>
        <Link href="#">Our Mission</Link>
        <Link href="#">We'd love to hear from you</Link>
        {isTherapy && (
          <div>
            <FDALabel>FDA Listing Number:</FDALabel>
            <FDAMessage href="https://accessgudid.nlm.nih.gov/devices/G629RESTORESKILLSTHERA0" target="_blank">
              G629RESTORESKILLSTHERA0
            </FDAMessage>
          </div>
        )}
      </FooterColumn>
      <FooterColumn>
        <ColumnHeader>FIND US HERE</ColumnHeader>
        <Link href="https://www.linkedin.com/company/restore-skills/" target="_blank">
          <SocialIcon src={LinkedIn} />
          LinkedIn
        </Link>
        <Link href="https://www.facebook.com/RestoreSkills/" target="_blank">
          <SocialIcon src={Facebook} />
          Facebook
        </Link>
        <Link href="https://twitter.com/RESTOREskills" target="_blank">
          <SocialIcon src={Twitter} />
          Twitter
        </Link>
      </FooterColumn>
      <FooterColumn>
        <ColumnHeader>YOUR RESTORE REP AT THE FACILITY</ColumnHeader>
        {champion && (
          <>
            {champion.firstName} {champion.lastName}
            <br />
            {champion.email}
          </>
        )}
      </FooterColumn>
    </Footer>
  );
};

export default PageFooter;
